<div class="header-card d-flex bottom-xs">
  <span class="tittle-row f-20">{{title}}</span>
</div>
<div class="content-card-blue">
    <div class="row-card" *ngFor="let item of shortcuts;let indice=index">
      <div class="icon-left">
        <em class="material-icons color-blue-light ">{{item.icon}}</em>
      </div>
      <div class="info-right">
          <span class="text-right">
           <a id="Accesos Rapidos _PTEC-Menu Derecha {{item.name}}" [routerLink]="item.routerLink" [queryParams]="item.queryParams?item.queryParams:{}">{{item.name}}</a>
          </span>
      </div>
    </div>

</div>
